export enum Icons {
  ADD = 'add',
  ALERT = 'alert',
  APARTMENT_ROOM = 'apartament-room',
  ARROW_CIRCLE_RIGHT = 'arrow-circle-right',
  ARROW_DOWN = 'arrow-down',
  ARROW_DOWN_FILLED = 'arrow-down-filled',
  ARROW_LEFT = 'arrow-left',
  ARROW_LEFT_BIG = 'arrow-left-big',
  ARROW_RIGHT = 'arrow-right',
  ARROW_UP = 'arrow-up',
  ARROW_UP_FILLED = 'arrow-up-filled',
  BANK_ADDRESS = 'bank-address',
  BARIFIN = 'barifin',
  BARIFLEX = 'bariflex',
  BUILDING = 'building',
  CANCEL = 'cancel',
  CHECK_MARK = 'check-mark',
  CIRCLE_PLUS = 'circle_plus',
  CLOSE = 'close',
  CLOSED_X = 'closed-x',
  COMPLETED = 'completed',
  COPYCLIPBOARD = 'copy-clipboard',
  DASHBOARD = 'dashboard',
  DISCLAIMER = 'disclaimer',
  DOWNLOAD = 'download',
  EDIT_PENCIL = 'edit-pencil',
  ENGINE = 'engine',
  EQUAL = 'equal',
  ERROR = 'error',
  ERROR_SMALL_RED = 'error-small-red',
  EXPAND = 'expand',
  EXTERNAL_LINK = 'external-link',
  EYE_OPEN = 'eye-open',
  EYE_CLOSE = 'eye-close',
  FILE_FILLED = 'file-filled',
  FOLDER = 'folder',
  FOLDER_PLUS = 'folder-plus',
  GIVE_UP = 'give-up',
  HELP_TOOL_TIP = 'help-tool-tip',
  HOME = 'home',
  HOUSE = 'house',
  IDENTIFICATION = 'identification',
  INFORMATION = 'information',
  KEBAB = 'kebab',
  LOCK = 'lock',
  LOGOUT = 'logout',
  MARITAL_STATUS = 'marital-status',
  MEGAPHONE = 'megaphone',
  MODAL_ERROR = 'modal-error',
  MODAL_SUCCESS = 'modal-success',
  MONEY = 'money',
  MORE = 'more',
  MUCH_ARROW_LEFT = 'much-arrow-left',
  MUCH_ARROW_RIGHT = 'much-arrow-right',
  NATURAL_PERSON = 'natural-person',
  OTHERS = 'others',
  PARTY = 'party',
  PERSON = 'person',
  PRICE = 'price',
  PRINTER = 'printer',
  PROFILE = 'profile',
  REDO = 'redo',
  RESIDENCE = 'residence',
  ROCKET = 'rocket',
  SAC = 'sac',
  SEARCH = 'search',
  SEARCH_ZIP_CODE = 'search-zip-code',
  SUCCESS = 'success',
  SUCCESS_GREEN_SMALL = 'success-green-small',
  SUCCESS_GREEN_SMALL_NO_FILL = 'success-green-small-no-fill',
  TERRAIN = 'terrain',
  TRASH = 'trash',
  USEBENS_INSURANCE = 'usebens-insurance',
  USER_PROFILE = 'user-profile',
  VIDEO = 'video',
  WARNING = 'warning',
  WARNING_ORANGE_SMALL = 'warning-orange-small',
  ZURICH_INSURANCE = 'zurich-insurance'
}
